var UbpEventi = (function () {

  /* ---------------------------------------------------------
  Module: Toggle Barre dei filtri progetti / eventi
  Added: 2016-06-28
  --------------------------------------------------------- */

  var toggleFiltriHeader = function () {

    // filters panel visibility toggle
    $('.post-type-archive-progetti #menu-principale-container .projects-toggle a').on('click', function(e){
    	e.preventDefault();
      $('#menu-tiles').toggleClass('erase');
    	$('#menu-filters').toggleClass('d-md-none');
    	$(this).toggleClass('active');
    });

    // visulizza i filtri nell'archivio progetti
    // if ( $('body.post-type-archive-progetti').length ) {
    // 	$('#projects-filters-panel').stop().show();
    // }

    // hack: i select 2 si aggiungono dei display block quindi nascondo tutto con la classe hidden
    $('#subfilters-menu-items li a').on('click',function(e){
    	var this_index = $(this).parent('li').index();
    	$('#subfilters-panels nav').addClass('hidden');
    	$('#subfilters-panels nav').eq(this_index).removeClass('hidden');
    });

    // initialize Select2 on menus
    // if ( $('#edizioni-select').length ) { $('#edizioni-select').select2({theme: 'bootstrap4'}); }
    // if ( $('#promotori-select').length ) { $('#promotori-select').select2({theme: 'bootstrap4'}); }
    if ( $('#luoghi-select').length ) { $('#luoghi-select').select2({theme: 'bootstrap4'}); }


    // filter global events by url parameter
    var urlFilter = RwUtil.getUrlParam('evento');

    if(urlFilter !== undefined){
      setTimeout(function(){
        $('#menu-eventi-items a[data-filter=".'+ urlFilter +'"]').click();
      }, 50);
    }

    /* ^ END module ----------------------------------------- */

  };



  /* ---------------------------------------------------------
  Module: SCRIPTS PAGINA EVENTI
  Added:
  --------------------------------------------------------- */
  var eventiScripts = function () {

    var $grid = $('#iso').isotope({
    filter: '*',
      itemSelector: '.item',
      layoutMode : 'packery'
    });

    // store filter for each group
    var filters = {};

    function concatValues( obj ) {
      var value = '';
      for ( var prop in obj ) {
        value += obj[ prop ];
      }
      return value;
    }

    $('.filters').on( 'click', '.gruppo-filtro a', function() {
      var $this = $(this);

      // filtri globali in archive eventi
      if($this.hasClass('global-filter')){
        const tipoEvento = $this.data('filter').replace('.','');
        const titolo = $this.attr('title');
        const info = $this.data('info');
        const thumb = $this.data('thumb');
        const home = $this.data('home');

        $('#titolo-evento').html(titolo);
        $('#titolo-evento').attr('href', home);
        $('#info-evento').html(info);
        $('#tile-sponsor img').attr('src', thumb);

        if(tipoEvento === '*'){
          $('#menu-eventi .header-box').addClass('bg-primary');
        } else {
          $('#menu-eventi .header-box').removeClass('bg-primary');
          $('#menu-eventi .header-box').css('background-color', 'var(--'+ tipoEvento +')');
        }
      }

      // get group key
      var $buttonGroup = $this.parents('.gruppo-filtro');
      var filterGroup = $buttonGroup.attr('data-filter-group');
      // set filter for group
      filters[ filterGroup ] = $this.attr('data-filter');
      // combine filters
      var filterValue = concatValues( filters );
      // set filter for Isotope
      $grid.isotope({ filter: filterValue });

      $('.gruppo-filtro a').removeClass('selected');
      $this.addClass('selected');
    });

    $('#luoghi-select').on('select2:select', function (e) {
      var data = e.params.data;
      // set filter for group
      filters['luoghi'] = data['id'];
      // combine filters
      var filterValue = concatValues( filters );
      // set filter for Isotope
      $grid.isotope({ filter: filterValue });
    });

  }


  /* ---------------------------------------------------------
  Module: ARCHIVIO EVENTI REDESIGN
  Filtri tipo-evento (buttons), giorno/sala/parole chiave (pannelli),
  cambio colore/titolo/icona header, Isotope grid.
  --------------------------------------------------------- */
  var archivioEventi = function () {
    var container = document.getElementById('iso-eventi');
    if (!container) return;

    var root = document.querySelector('.post-type-archive-eventi [comp="filtri-livello1"]');
    if (!root) return;

    // Init Isotope
    var $grid = $(container).isotope({
      filter: '*',
      itemSelector: '.item',
      layoutMode: 'fitRows'
    });

    // Filter state
    var currentTipoFilter = '*';
    var panelFilters = {}; // { 'panel-giorno': [values], 'panel-sala': [values], ... }

    // ── Cascading filters (shared module) ──
    var cascade = UbpFiltriCascade.create({
      root: root,
      getItems: function () {
        var items = [];
        container.querySelectorAll('.item').forEach(function (el) {
          items.push({
            classes: el.className,
            attrs: { giorno: el.getAttribute('data-giorno') || '' }
          });
        });
        return items;
      },
      panels: {
        'panel-giorno': {
          matchFn: function (item, value) {
            return item.attrs.giorno === value;
          }
        },
        'panel-sala': {
          matchFn: function (item, value) {
            return UbpFiltriCascade.hasClass(item.classes, value);
          }
        },
        'panel-parolechiave': {
          matchFn: function (item, value) {
            return UbpFiltriCascade.hasClass(item.classes, 'parolechiave-' + value);
          }
        }
      },
      barMatchFn: function (item, filterValue) {
        if (filterValue === '*') return true;
        var cls = filterValue.replace('.', '');
        return UbpFiltriCascade.hasClass(item.classes, cls);
      },
      onPanelChanged: function (panel) {
        collectPanelValues(panel);
        updatePanelTags(panel);
        // Reset single-select dropdown label if item was auto-deselected
        if (panel.getAttribute('data-select-mode') === 'single') {
          var ddBtn = root.querySelector('.dropdown[data-panel="' + panel.id + '"]');
          if (ddBtn) {
            var orig = ddBtn.getAttribute('data-original-label');
            var selected = panel.querySelector('.grid-item.--selected');
            if (orig && !selected) ddBtn.querySelector('.dropdown-label').textContent = orig;
          }
        }
      },
      onBarUpdate: function (activeWasHidden) {
        if (activeWasHidden) {
          currentTipoFilter = '*';
          // Reset header colors/title/icon
          var headerArea = document.querySelector('.post-type-archive-eventi > .container');
          var menuDesktop = document.querySelector('body > header');
          if (headerArea) { headerArea.style.backgroundColor = ''; headerArea.style.color = ''; headerArea.removeAttribute('data-tipo-active'); }
          if (menuDesktop) { menuDesktop.style.backgroundColor = ''; menuDesktop.style.color = ''; }
          var titoloEl = document.getElementById('titolo-tipo-evento');
          if (titoloEl) titoloEl.textContent = 'Tutti gli eventi';
          applyAllFilters();
        }
      }
    });

    // Initial cascade on page load
    cascade.update();

    // ── URL param: ?evento=gamma → auto-select tipo-evento ──
    var urlEvento = new URLSearchParams(window.location.search).get('evento');
    if (urlEvento) {
      var targetBtn = root.querySelector('.btn[data-filter=".' + urlEvento + '"]');
      if (targetBtn) {
        setTimeout(function () { targetBtn.click(); }, 100);
      }
    }

    // ── Combined filter function ──
    function getCurrentCombinedFilter() {
      return function () {
        var el = this;
        var $el = $(el);

        // Tipo evento (from buttons)
        if (currentTipoFilter !== '*') {
          if (!$el.is(currentTipoFilter)) return false;
        }

        // Panel filters (giorno, sala, parole chiave)
        for (var panelId in panelFilters) {
          var vals = panelFilters[panelId];
          if (!vals || vals.length === 0) continue;

          var panel = document.getElementById(panelId);
          var mode = panel ? panel.getAttribute('data-select-mode') : 'multiple';

          if (panelId === 'panel-giorno') {
            // Match data-giorno attribute
            var giorno = el.getAttribute('data-giorno') || '';
            if (vals.indexOf(giorno) === -1) return false;
          } else if (panelId === 'panel-sala') {
            // Match class (sede-evento-nameslug-xxx)
            var matched = false;
            for (var i = 0; i < vals.length; i++) {
              if ($el.hasClass(vals[i])) { matched = true; break; }
            }
            if (!matched) return false;
          } else if (panelId === 'panel-parolechiave') {
            // Match parolechiave-{slug} classes
            var matched = false;
            for (var i = 0; i < vals.length; i++) {
              if ($el.hasClass('parolechiave-' + vals[i])) { matched = true; break; }
            }
            if (!matched) return false;
          }
        }

        return true;
      };
    }

    function applyAllFilters() {
      $grid.isotope({ filter: getCurrentCombinedFilter() });
      updateClearAllButton();
    }

    // ── Clear all button ──
    function updateClearAllButton() {
      var clearBtn = root.querySelector('.clear-all');
      if (!clearBtn) return;

      var count = 0;
      if (currentTipoFilter !== '*') count++;
      for (var pid in panelFilters) {
        if (panelFilters[pid] && panelFilters[pid].length > 0) count++;
      }

      clearBtn.style.display = count > 0 ? 'flex' : 'none';
      var countSpan = clearBtn.querySelector('.clear-count');
      if (countSpan) countSpan.textContent = count > 0 ? '(' + count + ')' : '';
    }

    // ── Tipo-evento buttons ──
    root.querySelectorAll('.btn[data-filter]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('.btn[data-filter]').forEach(function (b) {
          b.classList.remove('--active');
        });
        this.classList.add('--active');

        var filterVal = this.getAttribute('data-filter');
        currentTipoFilter = filterVal;

        // Cambio titolo sezione
        var titoloEl = document.getElementById('titolo-tipo-evento');
        if (titoloEl) {
          titoloEl.textContent = filterVal === '*' ? 'Tutti gli eventi' : this.textContent.trim();
        }

        // Cambio colore sfondo header area (header + breadcrumbs + title + filtri)
        var headerArea = document.querySelector('.post-type-archive-eventi > .container');
        var menuDesktop = document.querySelector('body > header');
        var tipo = filterVal.replace('.', '');

        if (filterVal === '*') {
          // Reset a default
          if (headerArea) {
            headerArea.style.backgroundColor = '';
            headerArea.style.color = '';
            headerArea.removeAttribute('data-tipo-active');
          }
          if (menuDesktop) {
            menuDesktop.style.backgroundColor = '';
            menuDesktop.style.color = '';
          }
        } else {
          var bgColor = 'var(--' + tipo + ')';
          var textColor = 'var(--textile-' + tipo + ', var(--textile))';
          if (headerArea) {
            headerArea.style.backgroundColor = bgColor;
            headerArea.style.color = textColor;
            headerArea.setAttribute('data-tipo-active', tipo);
          }
          if (menuDesktop) {
            menuDesktop.style.backgroundColor = bgColor;
            menuDesktop.style.color = textColor;
          }
        }

        // Cambio icona — legge data-thumb dal button cliccato
        var iconContainer = document.getElementById('tipo-evento-icon');
        if (iconContainer) {
          var thumb = this.getAttribute('data-thumb');
          if (thumb) {
            iconContainer.innerHTML = '<img src="' + thumb + '" alt="">';
          }
          iconContainer.style.backgroundColor = filterVal === '*' ? '' : bgColor;
        }

        applyAllFilters();
        cascade.update();
      });
    });


    // ── Dropdown panel toggle ──
    root.querySelectorAll('.dropdown[data-panel]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panelId = this.getAttribute('data-panel');
        var panel = document.getElementById(panelId);
        if (!panel) return;

        var wasOpen = !panel.hidden;

        // Close all panels
        root.querySelectorAll('[comp="filtri-pannello"]').forEach(function (p) {
          p.hidden = true;
        });
        root.querySelectorAll('.dropdown').forEach(function (d) {
          d.classList.remove('is-open');
        });

        if (!wasOpen) {
          panel.hidden = false;
          this.classList.add('is-open');
        }
      });
    });

    // Close panels on click outside
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[comp="filtri-livello1"]')) {
        root.querySelectorAll('[comp="filtri-pannello"]').forEach(function (p) {
          p.hidden = true;
        });
        root.querySelectorAll('.dropdown').forEach(function (d) {
          d.classList.remove('is-open');
        });
      }
    });


    // ── Panel search ──
    root.querySelectorAll('[comp="filtri-pannello"] .search input').forEach(function (input) {
      input.addEventListener('keyup', function () {
        var query = this.value.toLowerCase();
        var panel = this.closest('[comp="filtri-pannello"]');
        panel.querySelectorAll('.grid-item').forEach(function (item) {
          item.style.display = item.textContent.toLowerCase().indexOf(query) !== -1 ? '' : 'none';
        });
      });
    });


    // ── Panel item selection ──
    root.querySelectorAll('[comp="filtri-pannello"]').forEach(function (panel) {
      var panelId = panel.id;
      var selectMode = panel.getAttribute('data-select-mode') || 'multiple';

      panel.querySelectorAll('.grid-item').forEach(function (item) {
        item.addEventListener('click', function () {
          if (selectMode === 'single') {
            // Single: deselect others, select this, close panel, apply
            var wasSelected = this.classList.contains('--selected');
            panel.querySelectorAll('.grid-item').forEach(function (gi) {
              gi.classList.remove('--selected');
            });
            if (!wasSelected) {
              this.classList.add('--selected');
            }

            // Update dropdown label
            var ddBtn = root.querySelector('.dropdown[data-panel="' + panelId + '"]');
            if (ddBtn) {
              var labelSpan = ddBtn.querySelector('.dropdown-label');
              var originalLabel = ddBtn.getAttribute('data-original-label');
              if (!originalLabel) {
                ddBtn.setAttribute('data-original-label', labelSpan.textContent);
                originalLabel = labelSpan.textContent;
              }
              labelSpan.textContent = wasSelected ? originalLabel : this.textContent.trim();
            }

            // Collect selected values
            collectPanelValues(panel);

            // Close panel and apply
            panel.hidden = true;
            root.querySelectorAll('.dropdown').forEach(function (d) {
              d.classList.remove('is-open');
            });
            applyAllFilters();
            cascade.update();

          } else {
            // Multiple: toggle
            this.classList.toggle('--selected');
            updatePanelTags(panel);
          }
        });
      });

      // ── Panel "Reset" (multiple only) ──
      var resetBtn = panel.querySelector('.reset');
      if (resetBtn) {
        resetBtn.addEventListener('click', function () {
          panel.querySelectorAll('.grid-item.--selected').forEach(function (gi) {
            gi.classList.remove('--selected');
          });
          updatePanelTags(panel);
          collectPanelValues(panel);
          applyAllFilters();
          cascade.update();
          panel.hidden = true;
          root.querySelectorAll('.dropdown').forEach(function (d) {
            d.classList.remove('is-open');
          });
        });
      }

      // ── Panel "Applica filtri" (multiple only) ──
      var applyBtn = panel.querySelector('[comp="button"]');
      if (applyBtn) {
        applyBtn.addEventListener('click', function (e) {
          e.preventDefault();
          collectPanelValues(panel);
          panel.hidden = true;
          root.querySelectorAll('.dropdown').forEach(function (d) {
            d.classList.remove('is-open');
          });
          applyAllFilters();
          cascade.update();
        });
      }
    });


    // ── "Cancella tutti i filtri" ──
    var clearAllBtn = root.querySelector('.clear-all');
    if (clearAllBtn) {
      clearAllBtn.addEventListener('click', function () {
        // Reset tipo-evento
        currentTipoFilter = '*';
        root.querySelectorAll('.btn[data-filter]').forEach(function (b) {
          b.classList.remove('--active');
        });
        var allBtn = root.querySelector('.btn[data-filter="*"]');
        if (allBtn) allBtn.classList.add('--active');

        // Reset panels
        root.querySelectorAll('[comp="filtri-pannello"]').forEach(function (panel) {
          panel.querySelectorAll('.grid-item.--selected').forEach(function (gi) {
            gi.classList.remove('--selected');
          });
          updatePanelTags(panel);
          collectPanelValues(panel);

          // Reset single-select dropdown labels
          if (panel.getAttribute('data-select-mode') === 'single') {
            var ddBtn = root.querySelector('.dropdown[data-panel="' + panel.id + '"]');
            if (ddBtn) {
              var orig = ddBtn.getAttribute('data-original-label');
              if (orig) ddBtn.querySelector('.dropdown-label').textContent = orig;
            }
          }
        });

        // Reset header colors
        var headerArea = document.querySelector('.post-type-archive-eventi > .container');
        var menuDesktop = document.querySelector('body > header');
        if (headerArea) { headerArea.style.backgroundColor = ''; headerArea.style.color = ''; headerArea.removeAttribute('data-tipo-active'); }
        if (menuDesktop) { menuDesktop.style.backgroundColor = ''; menuDesktop.style.color = ''; }

        // Reset title
        var titoloEl = document.getElementById('titolo-tipo-evento');
        if (titoloEl) titoloEl.textContent = 'Tutti gli eventi';

        // Reset icon — usa thumb del button "Tutti" (data-filter="*")
        var iconContainer = document.getElementById('tipo-evento-icon');
        if (iconContainer) {
          var allBtnThumb = allBtn ? allBtn.getAttribute('data-thumb') : iconContainer.getAttribute('data-default-icon');
          iconContainer.innerHTML = allBtnThumb ? '<img src="' + allBtnThumb + '" alt="">' : '';
          iconContainer.style.backgroundColor = '';
        }

        // Close panels
        root.querySelectorAll('[comp="filtri-pannello"]').forEach(function (p) { p.hidden = true; });
        root.querySelectorAll('.dropdown').forEach(function (d) { d.classList.remove('is-open'); });

        applyAllFilters();
        cascade.update();
      });
    }


    // ── Helper: collect selected values from panel ──
    function collectPanelValues(panel) {
      var vals = [];
      panel.querySelectorAll('.grid-item.--selected').forEach(function (item) {
        vals.push(item.getAttribute('data-value'));
      });
      panelFilters[panel.id] = vals;
    }

    // ── Helper: update panel tags + dropdown count (multiple panels) ──
    function updatePanelTags(panel) {
      var tagsContainer = panel.querySelector('.tags');
      if (tagsContainer) {
        tagsContainer.innerHTML = '';
        panel.querySelectorAll('.grid-item.--selected').forEach(function (item) {
          var tag = document.createElement('button');
          tag.type = 'button';
          tag.className = 'tag';
          tag.innerHTML = item.textContent + ' <span class="material-symbols-outlined">close_small</span>';
          tag.addEventListener('click', function () {
            item.classList.remove('--selected');
            updatePanelTags(panel);
          });
          tagsContainer.appendChild(tag);
        });
      }

      // Update dropdown count
      var ddBtn = root.querySelector('.dropdown[data-panel="' + panel.id + '"]');
      if (ddBtn) {
        var count = panel.querySelectorAll('.grid-item.--selected').length;
        var countSpan = ddBtn.querySelector('.dropdown-count');
        if (count > 0) {
          ddBtn.classList.add('--has-count');
          if (!countSpan) {
            countSpan = document.createElement('span');
            countSpan.className = 'dropdown-count';
            ddBtn.querySelector('.dropdown-label').insertAdjacentElement('afterend', countSpan);
          }
          countSpan.textContent = '(' + count + ')';
        } else {
          ddBtn.classList.remove('--has-count');
          if (countSpan) countSpan.remove();
        }
      }
    }


    // ───────────────────────────────────────────────────────────────────────
    // MOBILE: filter modal (Filtra per) + views bottom-sheet (.more)
    // ───────────────────────────────────────────────────────────────────────

    function reorderPanelsInline() {
      root.querySelectorAll('.dropdowns .dropdown[data-panel]').forEach(function (dd) {
        var panel = document.getElementById(dd.getAttribute('data-panel'));
        if (panel && dd.parentNode) {
          dd.parentNode.insertBefore(panel, dd.nextSibling);
        }
      });
    }
    function restorePanelsToContainer() {
      var pcontainer = root.querySelector('.panels-container');
      if (!pcontainer) { return; }
      root.querySelectorAll('.dropdowns [comp="filtri-pannello"]').forEach(function (p) {
        pcontainer.appendChild(p);
      });
    }
    function openFilterModal() {
      reorderPanelsInline();
      root.classList.add('--modal-open');
    }
    function closeFilterModal() {
      root.classList.remove('--modal-open');
      root.querySelectorAll('[comp="filtri-pannello"]').forEach(function (p) { p.hidden = true; });
      root.querySelectorAll('.dropdown.is-open').forEach(function (d) { d.classList.remove('is-open'); });
      restorePanelsToContainer();
    }

    var filterTrigger    = root.querySelector('.filter-trigger');
    var filterModalClose = root.querySelector('.filter-modal-close');
    var filterModalApply = root.querySelector('.filter-modal-apply');
    var filterModalReset = root.querySelector('.filter-modal-reset');
    var triggerClear      = root.querySelector('.filter-trigger-clear');
    var triggerClearCount = root.querySelector('.filter-trigger-clear-count');
    var clearAllBtnRef    = root.querySelector('.clear-all');

    function syncTriggerClear() {
      if (!clearAllBtnRef || !triggerClear) { return; }
      var visible = clearAllBtnRef.style.display !== 'none';
      triggerClear.hidden = !visible;
      if (visible && triggerClearCount) {
        var countEl = clearAllBtnRef.querySelector('.clear-count');
        triggerClearCount.textContent = countEl ? countEl.textContent : '';
      }
    }
    if (clearAllBtnRef && triggerClear) {
      syncTriggerClear();
      var triggerClearObs = new MutationObserver(syncTriggerClear);
      triggerClearObs.observe(clearAllBtnRef, {
        attributes: true,
        attributeFilter: ['style'],
        childList: true,
        subtree: true,
        characterData: true
      });
    }
    if (triggerClear && clearAllBtnRef) {
      triggerClear.addEventListener('click', function () {
        clearAllBtnRef.click();
      });
    }

    if (filterTrigger) {
      filterTrigger.addEventListener('click', function (e) {
        e.stopPropagation();
        openFilterModal();
      });
    }
    if (filterModalClose) {
      filterModalClose.addEventListener('click', function () { closeFilterModal(); });
    }
    if (filterModalApply) {
      filterModalApply.addEventListener('click', function () {
        var panelApply = root.querySelector('[comp="filtri-pannello"] [comp="button"]');
        if (panelApply) { panelApply.click(); }
        closeFilterModal();
      });
    }
    if (filterModalReset) {
      filterModalReset.addEventListener('click', function () {
        var clearAllBtn = root.querySelector('.clear-all');
        if (clearAllBtn) { clearAllBtn.click(); }
        closeFilterModal();
      });
    }

    var moreBtnMobile = root.querySelector('.bar .more');
    if (moreBtnMobile) {
      moreBtnMobile.addEventListener('click', function (e) {
        e.stopPropagation();
        root.classList.toggle('--views-open');
      });
    }

    document.addEventListener('click', function (e) {
      if (!root.classList.contains('--views-open')) { return; }
      if (e.target.closest('.views-sheet') || e.target.closest('.bar .more')) { return; }
      root.classList.remove('--views-open');
    });

    root.querySelectorAll('.views-sheet-option').forEach(function (opt) {
      opt.addEventListener('click', function () {
        var mode = this.getAttribute('data-view');
        root.querySelectorAll('.views-sheet-option').forEach(function (b) {
          b.classList.toggle('--active', b.getAttribute('data-view') === mode);
        });
        root.querySelectorAll('.view-btn').forEach(function (b) {
          b.classList.toggle('--active', b.getAttribute('data-view') === mode);
        });
        var viewBtn = root.querySelector('.view-btn[data-view="' + mode + '"]');
        if (viewBtn) { viewBtn.click(); }
        root.classList.remove('--views-open');
      });
    });

  };


  return {
    toggleFiltriHeader : toggleFiltriHeader,
    eventiScripts : eventiScripts,
    archivioEventi : archivioEventi
  }


})();
